'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AiSecurity = function (_React$Component) {
    _inherits(AiSecurity, _React$Component);

    function AiSecurity() {
        _classCallCheck(this, AiSecurity);

        return _possibleConstructorReturn(this, (AiSecurity.__proto__ || Object.getPrototypeOf(AiSecurity)).apply(this, arguments));
    }

    _createClass(AiSecurity, [{
        key: 'svgPath',
        value: function svgPath(strokeColor, strokeWidth) {
            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement(
                    'g',
                    null,
                    _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M44.735,34.279v-3.113c0-1.66-1.425-3.003-3.181-3.003h-19.11c-1.756,0-3.18,1.344-3.18,3.003v13.827 c0,1.661,1.424,3.007,3.18,3.007h19.11c1.756,0,3.181-1.346,3.181-3.007v-0.945h-4.167v-1.662h4.167v-2.288h-4.167v-1.662h4.167 V35.94h-4.167v-1.661H44.735z M33.115,39.688v2.086c0,0.484-0.498,0.879-1.116,0.879c-0.615,0-1.116-0.395-1.116-0.879v-2.086 c-0.863-0.417-1.458-1.296-1.458-2.318c0-1.42,1.152-2.574,2.575-2.574c1.421,0,2.575,1.154,2.575,2.574 C34.574,38.391,33.974,39.271,33.115,39.688z' }),
                    _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, d: 'M25.367,23.922c0-2.766,2.245-5.012,5.014-5.012h3.238c2.768,0,5.016,2.246,5.016,5.012v3.51h3.551V22.86 c0-3.79-3.069-6.86-6.861-6.86h-6.65c-3.79,0-6.861,3.07-6.861,6.86v4.572h3.553C25.367,27.432,25.367,23.922,25.367,23.922z' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var strokeColor = this.props.strokeColor || 'white';
            var strokeWidth = this.props.strokeWidth || 0;
            var viewBox = '0 0 64 64';
            var style = {
                fontSize: '200%',
                verticalAlign: '-23%'
            };

            if (this.props.noPad) {
                viewBox = '16 16 32 32';
                style = {};
            }

            var props = _underscore2.default.omit(this.props, 'noPad', 'strokeColor');

            if (this.props.strokeWidth > 0) {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-security', viewBox: viewBox, style: style }, props),
                    this.svgPath(strokeColor, strokeWidth),
                    this.svgPath('white', 0)
                );
            } else {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-security', viewBox: viewBox, style: style }, props),
                    this.svgPath('white', 0)
                );
            }
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return Object.assign({}, _reactIconBase2.default.propTypes, {
                strokeColor: _propTypes2.default.string,
                strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
                noPad: _propTypes2.default.bool
            });
        }
    }]);

    return AiSecurity;
}(_react2.default.Component);

exports.default = AiSecurity;